import { useEffect } from "react";
import { STATUS_SITE_URL } from "../lib/env";

/** Legacy /status route — sends visitors to the standalone status subdomain. */
export default function StatusRedirect() {
    useEffect(() => {
        window.location.replace(STATUS_SITE_URL);
    }, []);

    return (
        <div className="min-h-[50vh] flex flex-col items-center justify-center gap-3 text-zinc-400 text-sm">
            <p>Redirecting to system status…</p>
            <a
                href={STATUS_SITE_URL}
                className="text-electric hover:underline"
            >
                Continue to {STATUS_SITE_URL.replace(/^https?:\/\//, "")}
            </a>
        </div>
    );
}
